import firebase from 'firebase'
import { db } from '../../config/firebaseconfig'

/**
 * Saves the new subtest report to db, then sends it to redux store.
 * @param {object} newReport Generated by newSubtestReport.js
 * @param {string} subtestId Id of the subtest
 * @param {object} userAssessment Object from db.collection('userAssessments')
 * @param {function} setSubtestReport Action creator from assessment.js
 */
export default function saveSubtestReport (newReport, subtestId, userAssessment, setSubtestReport) {
  const userAssessmentId = userAssessment.userAssessmentId
  const report = {
    id: newReport.id,
    report: newReport.report,
    subtestId,
    userAssessmentId,
  }
  const batch = db.batch()
  const userAssessmentRef = db.collection('userAssessments').doc(userAssessmentId)
  const reportRef = db.collection('subtestReports').doc(report.id)
  const uAKey = `reports.${subtestId}`
  batch.update(userAssessmentRef, {[uAKey]: {[report.id]: true}})
  batch.set(reportRef, report)
  batch.commit()
    .then(() => {
      setSubtestReport(report)
    })
    .catch((err) => console.log(err))
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/saveSubtestReport.js